/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["media-image{overflow:hidden}media-image img{width:100%;height:auto;-o-object-fit:cover;object-fit:cover}media-image img.ng-lazyloaded{-webkit-animation:.5s fadein;animation:.5s fadein}@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}"];
export { styles as styles };
